// extracted by mini-css-extract-plugin
export default {"isKeyboardDragging":"DragAndDropContainer-module__isKeyboardDragging--o7t_f","container":"DragAndDropContainer-module__container--hRASh"};